export const LOCALES = {
    ENGLISH: "en-US",
};